import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class NewHireSummary extends DomainObject {
  @observable newHireCount;
  @observable pastStartCount;
}

export default NewHireSummary;
